import React from "react";
import { indexStore } from "../../../store/indexStore";
import { MainDialog } from "src/Components/Dialgos/MainDialog";
import { useTranslation } from "react-i18next";
import SettingstForm from "./form/SettingsForm";

function EditSettingModel(props) {
  const { t } = useTranslation();
  const { settings,updateSettingsFunction,  } = indexStore();

  const handleSubmitEditSettings = (values) => {
    updateSettingsFunction(values);
  };

  return (
    <MainDialog

      trigger={props.trigger}
      title={`${t("gloabl.edit")} ${t(`gloabl.settings`)}`}
    >
      <SettingstForm
        onSubmit={handleSubmitEditSettings}
        editMode={true}
        datasource={settings}
      />
    </MainDialog>
  );
}

export default EditSettingModel;
